"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowDownRightIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ArrowDownRightIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M16.8148318,13.6048887 L13.8228987,10.4754269 L12.9315861,11.4077101 L14.8483129,13.4118833 L8.2597613,13.4118833 L8.2597613,6 L7,6 L7,14.0707174 C7,14.2457202 7.06643351,14.4129981 7.18453928,14.5365295 C7.30264505,14.6600609 7.4625686,14.7295514 7.62988065,14.7295514 L14.8483129,14.7295514 L12.932216,16.7343835 L13.8235286,17.6666667 L16.8154617,14.5372048 L16.8148466,14.5372048 C16.9335649,14.4136734 17,14.2457531 17,14.0707503 C17,13.8963899 16.9335665,13.7284695 16.8148466,13.6049381 L16.8148318,13.6048887 Z" }))); };
exports.ArrowDownRightIcon = ArrowDownRightIcon;
